export default function getIsAdmin(user, telegramUser) {
    // Проверяем поле is_admin для обычных пользователей
    if (user && user.is_admin) {
        return true;
    }
    
    // Специальный случай для пользователя с ID 22 (временное решение)
    if (user && user.id === 22) {
        return true;
    }
    
    // Для Telegram пользователей проверяем ID 22 (временное решение)
    if (telegramUser && telegramUser.id === 22) {
        return true;
    }
    
    return false;
}
